module.exports = __webpack_public_path__ + "img/cell-grid-dark-01.26a7a774.jpg";